import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import React from "react";
import { Link } from "react-router-dom";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(src, width = 800, quality = 80) {
  if (!src) return src;
  if (typeof src !== 'string') return src;
  if (src.startsWith('https://assets.auxodev.dk/')) {
    if (src.includes('/cdn-cgi/image/')) return src;
    return src.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`);
  }
  return src;
}

export function renderFormattedText(text, options = {}) {
  if (typeof text !== 'string') return text;
  const { isDark = false } = options;
  const regex = /(\*\*.*?\*\*|\[.*?\]\(.*?\))/g;
  const parts = text.split(regex);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return React.createElement(
        'strong',
        {
          key: i,
          className: `font-bold ${isDark ? 'text-white' : 'text-stone-900'}`
        },
        part.slice(2, -2)
      );
    }
    const linkMatch = part.match(/^\[(.*?)\]\((.*?)\)$/);
    if (linkMatch) {
      const linkText = linkMatch[1];
      const linkUrl = linkMatch[2];
      return React.createElement(
        Link,
        {
          key: i,
          to: linkUrl,
          className: `${
            isDark
              ? 'text-orange-400 hover:text-orange-300 underline underline-offset-4 decoration-orange-400/70 font-semibold'
              : 'text-orange-600 hover:text-orange-700 underline underline-offset-4 decoration-orange-500/70 font-semibold'
          } transition-colors`
        },
        linkText
      );
    }
    return part;
  });
}


